module.exports = __webpack_public_path__ + "static/media/pic_yanzheng.5b062002.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/pic_yanzheng.svg
// module id = 239
// module chunks = 0